export default __webpack_public_path__ + "1c135a8888ae30795af6ee5518d5bcff.png";